<template>
  <div>
    <select class="lSelect lSelect946540 col-xs-12 col-sm-12 col-md-3" style="margin-right: 10px;" @change="proChange">
      <option :value="item.value" v-for="(item, index) in province" :selected="item.value === one ? 'selected' : ''">{{item.title}}</option>
    </select>
    <select class="lSelect lSelect946540 col-xs-12 col-sm-12 col-md-3" style="margin-right: 10px;" @change="cityChange">
      <option value="">{{text}}</option>
      <option :value="item.value" v-for="(item, index) in city" :selected="item.value === two ? 'selected' : ''">{{item.title}}</option>
    </select>
    <select class="lSelect lSelect946540 col-xs-12 col-sm-12 col-md-3" @change="countyChange">
      <option value="">{{text}}</option>
      <option :value="item.value" v-for="(item, index) in county" :selected="item.value === three ? 'selected' : ''">{{item.title}}</option>
    </select>
  </div>
</template>

<script>
import province from './../utils/province'
export default {
  props: ['one', 'two', 'three'],
  data () {
    return {
      province: province,
      city: [],
      county: [],
      text: '请选择'
    }
  },
  mounted () {
    this.getCity(this.one, 1)
    this.getCity(this.two, 2)
  },
  methods: {
    getCity (path, type) {
      var ctx = this
      path && window.$.ajax({
        url: '/rest/api/shop/area/childrenArea?path=' + path,
        success (res) {
          let data = JSON.parse(res.attributes.data) || []
          if (type === 1) {
            ctx.city = data
            ctx.county = []
          }
          if (type === 2) { ctx.county = data }
          ctx.text = '请选择'
        }
      })
    },
    proChange (e) {
      this.getCity(e.target.value, 1)
      this.city = []
      this.text = '加载中'
      this.change(e.target.value)
    },
    cityChange (e) {
      this.getCity(e.target.value, 2)
      this.county = []
      this.text = '加载中'
      this.change(e.target.value)
    },
    countyChange (e) {
      this.change(e.target.value)
    },
    change (a) {
      this.$emit('change', a)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Area.vue